import React from 'react'
import cuid from 'cuid'
import classnames from 'classnames'
import Configurator from '../../../configurator'
import { i18n } from '../../../validator'

/**
 * @description Base textarea definition
 *      USAGE
 *          <TextArea
 *              *** PROPS ***
 *          />
 *
 *      PROPS - all props are optional
 *          id                  - id of input with label (if not defined, id will be generated)
 *          label               - label title (if not defined or null, is not showed)
 *          error               - label with error message (if not defined or null, is not showed)
 *          placeholder         - placeholder of input
 *          disabled            - disable input
 *          value               - default value for textarea
 *          required            - if textarea is required
 *          inputRef            - ref to input
 *          containerClassName  - additional classes for div container
 *          labelClassName      - additional classes for label
 *          className           - additional classes for textarea
 *          onChange            - function callback after change input
 */
@i18n()
export default class TextArea extends Configurator {

    state = {
        id: this.props.id || cuid(),
    }

    /**
     * Render
     *
     * @return {*}
     */
    render = () => {
        const {
            label,
            error,
            required,
            disabled,
            placeholder,
            containerClassName,
            labelClassName,
            className,
            value,
            inputRef,
            t,
            ...restProps
        } = this.props

        const { id } = this.state

        return (
            <div className={classnames({
                'form-group': true,
                [containerClassName]: !!containerClassName,
            })}>
                {label &&
                    <label
                        htmlFor={id}
                        className={classnames({
                            [labelClassName]: !!labelClassName,
                        })}
                    >
                        {label}
                        {required &&
                            <small className="text-danger">&nbsp;({t('required')})</small>
                        }
                    </label>
                }
                <textarea
                    id={id}
                    name={name || ''}
                    className={classnames({
                        'form-control': true,
                        'form-control--error': error,
                        [className]: !!className,
                    })}
                    placeholder={placeholder || ''}
                    value={value || ''}
                    required={required}
                    ref={inputRef}
                    disabled={disabled}
                    {...restProps}
                />
                {error &&
                    <div className="form-error-label">{error}</div>
                }
            </div>
        )
    }
}
